import { dictionaryCamelCaseConverter } from 'src/utils/dictionaryCamelCaseConverter';

export const sanitizeCompanySizeTurnover = (data) => dictionaryCamelCaseConverter(data);
